import React, { FC } from 'react';

import { PhoneInput, type PhoneInputProps } from 'app/design-system/components/PhoneInput';

import InputWithAnalytics from './Input';

type PhoneInputWithAnalyticsProps = Omit<PhoneInputProps, 'customInput'>;

const PhoneInputWithAnalytics: FC<PhoneInputWithAnalyticsProps> = (props) => {
  return (
    <PhoneInput {...props}
                customInput={InputWithAnalytics} />
  );
};

export default PhoneInputWithAnalytics;
export * from 'app/design-system/components/PhoneInput';
